import React from 'react';

const RhinoVOIPFax = () => <div>Fax content</div>;

export default RhinoVOIPFax;
